import { KnobTheme } from 'styled-components';

import { colors } from '@controlrooms/design-tokens';

export const knobDarkTheme: KnobTheme = {
  backgroundColor: colors.button.dark['ui-button-1'],
  knobBorderColor: colors.focus.dark[5],
  knobDialBackground: '#172426',
  knobDialBoxshadow:
    '0px 1px 1px 0px rgb(79, 79, 79, 0.29) inset, -1px -4px 4px 0px rgb(255, 255, 255, 0.1),  0px -2px 2px 0px rgb(0, 0, 0, 0.41) inset, 0px 4px 4px 0px rgb(33, 33, 33, 0.25)',
  knobDialInnerBackground: '#19282a',
  knobDialhandle: colors.content['neutral-1'],
  knobDialhandleBorder: colors.content['neutral-4'],
  knobDialFilter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.68))',
  valueLabelColor: colors.content['neutral-4'],
  valueColor: colors.content['neutral-1'],
  progressBarColor: colors.focus.dark[1],
};

export const knobLightTheme: KnobTheme = {
  backgroundColor: colors.button.light['ui-button-1'],
  knobBorderColor: colors.container['b-g-5'],
  knobDialBackground: `#E5E3E1`,
  knobDialBoxshadow:
    '1px -4px 3px 0px rgb(255 255 255 / 0%) inset, -2px -5px 4px 0px rgb(231 229 230 / 70%), 0px -2px 2px 0px rgb(87 87 87 / 50%) inset, 0px 4px 4px 0px rgb(0 0 0 / 35%)',
  knobDialInnerBackground: '#E5E3E1',
  knobDialhandle: colors.content['neutral-6'],
  knobDialhandleBorder: colors.content['neutral-1'],
  knobDialFilter: 'none',
  valueLabelColor: colors.content['neutral-4'],
  valueColor: colors.content['neutral-6'],
  progressBarColor: colors.focus.light[1],
};
